module.exports = __webpack_public_path__ + "img/c-bg2.76edbd49.jpg";